import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitMessage('');

    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitMessage('Thank you for subscribing!');
      setEmail('');
      setTimeout(() => setSubmitMessage(''), 3000);
    }, 1000);
  };

  return (
    <footer className="bg-[#3D3460] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 space-y-6">
              <img
                src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/30cd5c946db28922bece6f59f0351006.jpeg"
                alt="KaliKare Homecare"
                className="h-16 w-auto"
              />

              <a
                href="tel:833-438-5542"
                className="flex items-center justify-center gap-3 bg-purple-700 hover:bg-purple-600 text-white px-6 py-3 rounded-lg transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="fas fa-phone"></i>
                833-438-5542
              </a>

              <a
                href="mailto:info@kalikarehomecare.com"
                className="flex items-center justify-center gap-3 bg-purple-700 hover:bg-purple-600 text-white px-6 py-3 rounded-lg transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="fas fa-envelope"></i>
                info@kalikarehomecare.com
              </a>

              <a
                href="https://www.google.com/maps/dir//201+King+of+Prussia+Rd+Suite+650,+Wayne,+PA+19089/@40.0437773,-75.4394648,12z"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 bg-purple-700 hover:bg-purple-600 text-white px-6 py-3 rounded-lg transition-colors text-sm font-medium cursor-pointer"
              >
                <i className="fas fa-map-pin"></i>
                <span className="text-left">201 King of Prussia Rd, Ste 650 Radnor Pa 19087</span>
              </a>

              <div className="flex items-center justify-center gap-4 pt-4">
                <a
                  href="https://www.linkedin.com/company/kalikarehomecare/about/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-orange-500 rounded-full transition-colors cursor-pointer"
                >
                  <i className="fab fa-linkedin text-xl"></i>
                </a>
                <a
                  href="https://www.instagram.com/kali_kare_homecare/?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-12 h-12 flex items-center justify-center bg-white/20 hover:bg-orange-500 rounded-full transition-colors cursor-pointer"
                >
                  <i className="fab fa-instagram text-xl"></i>
                </a>
              </div>
            </div>

          </div>

          <div className="flex items-center justify-center">
            <img
              src="https://static.readdy.ai/image/c5f8f34d4f8bde8dadcc5d50fcd889fd/a21eb33c4411165944ca014beeeeb932.jpeg"
              alt="KaliKare Team"
              className="w-full h-auto rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      </div>

      <div className="bg-orange-500 py-12">
        <div className="max-w-3xl mx-auto px-6 sm:px-10 lg:px-12">
          <h4 className="text-center text-white text-xl font-bold mb-6">Stay Up To Date With Us</h4>
          <form onSubmit={handleSubmit} className="flex gap-4">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Your Email"
              required
              className="flex-1 px-6 py-3 rounded-lg text-gray-900 text-sm focus:outline-none focus:ring-2 focus:ring-white"
            />
            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-white text-orange-600 px-8 py-3 rounded-lg font-semibold hover:bg-purple-50 transition-colors text-sm whitespace-nowrap cursor-pointer disabled:opacity-50"
            >
              {isSubmitting ? 'Subscribing...' : 'Subscribe'}
            </button>
          </form>
          {submitMessage && (
            <p className="text-center text-white mt-4 text-sm font-medium">{submitMessage}</p>
          )}
        </div>
      </div>

      <div className="bg-[#2A2445] py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-center text-sm text-purple-300">
            Copyright ©2026 by KaliKare Homecare LLC All Rights Reserved |{' '}
            <a href="https://www.zilladelphia.com" className="text-orange-400 hover:text-orange-300 cursor-pointer">
              Design by Zilladelphia
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}